import { reportTypeDisplayMap } from '../../../infrastructure/constants/reportType';
import ReportingRegime from '../../../infrastructure/types/common/ReportingRegime';

const guidance = {
    name: 'Free text to identify the reporting configuration uniquely.',
    description: 'Describe the purpose of this reporting configuration.',
    regime: Object.keys(ReportingRegime).join(' or '),
    reportType: Object.values(reportTypeDisplayMap).map(x => `'${x}'`).join(' or '),
    rawDataSource: 'Select only one file which will be used as the Raw file. User can select only those files where File Data Type is either Raw or Both.',
    refDataSources: 'Select one (or more) files to be used as Reference files by the tool. User can select only those files where File Data Type is either Ref or Both.',
    globalRefDataSources: 'Select one (or more) files to be used as Global Reference files by the tool',
    optionalModules: 'Opional modules'
};

export default guidance;
